const DETAIL_BY_OPTIONS = [
  { value: 200, label: 'Khách hàng' },
  { value: 210, label: 'Nhóm khách 1' },
  { value: 220, label: 'Nhóm khách 2' },
  { value: 230, label: 'Nhóm khách 3' },
  { value: 300, label: 'Vật tư' },
  { value: 320, label: 'Nhóm vật tư 1' },
  { value: 330, label: 'Nhóm vật tư 2' },
  { value: 340, label: 'Nhóm vật tư 3' },
  { value: 700, label: 'Đơn vị' },
  { value: 810, label: 'Bộ phận' },
  { value: 820, label: 'Vụ việc' },
  { value: 830, label: 'Hợp đồng' },
  { value: 840, label: 'Khế ước' },
  { value: 850, label: 'Phí' },
  { value: 860, label: 'Sản phẩm' },
  { value: 870, label: 'Lệnh sản xuất' },
  { value: 910, label: 'Nhân viên bán hàng' }
];

const GROUP_BY_OPTIONS = [
  { value: 0, label: 'Không nhóm' },
  { value: 200, label: 'Khách hàng' },
  { value: 210, label: 'Nhóm khách 1' },
  { value: 220, label: 'Nhóm khách 2' },
  { value: 230, label: 'Nhóm khách 3' },
  { value: 300, label: 'Vật tư' },
  { value: 320, label: 'Nhóm vật tư 1' },
  { value: 330, label: 'Nhóm vật tư 2' },
  { value: 340, label: 'Nhóm vật tư 3' },
  { value: 700, label: 'Đơn vị' },
  { value: 810, label: 'Bộ phận' },
  { value: 820, label: 'Vụ việc' },
  { value: 830, label: 'Hợp đồng' },
  { value: 840, label: 'Khế ước' },
  { value: 850, label: 'Phí' },
  { value: 860, label: 'Sản phẩm' },
  { value: 870, label: 'Lệnh sản xuất' },
  { value: 910, label: 'Nhân viên bán hàng' }
];

export { DETAIL_BY_OPTIONS, GROUP_BY_OPTIONS };
